import React from 'react';

interface RegisterCardProps {
  image: string;
  title: string;
  description: string;
}

const RegisterCard: React.FC<RegisterCardProps> = ({
  image,
  title,
  description,
}) => {
  return (
    <div className="flex w-full flex-col items-center justify-start gap-5 px-4 py-8 text-center lg:px-6">
      <img
        className="h-[150px] w-[150px]"
        src={image}
        alt="advantage"
        loading="lazy"
      />
      <div className="font-semibold text-primary text-xl">{title}</div>
      <div className="text-base">{description}</div>
    </div>
  );
};

export default RegisterCard;
